import React from "react";
import { CrossCircleIcon } from "../../images/icons/icons";

const BankDetails = ({ modName, rowData }) => {
  const {
    bank_name,
    account_number,
    bank_statement,
    ifsc_code,
    lease_agreement,
    electricity_bill,
  } = rowData || {};

  return (
    <div className="mini-tb-container mt30">
      <ul className="tb-section tb-section-1">
        {modName === "all_documents" && (
          <>
            <li className="tb-section-item tb-section-item-lable">
              lease agreement
            </li>
            <li className="tb-section-item tb-section-item-lable">
              electricity bill
            </li>
            <li className="tb-section-item tb-section-item-lable">
              bank statement
            </li>
          </>
        )}

        {modName === "bank_statement" && (
          <>
            <li className="tb-section-item tb-section-item-lable">bank name</li>
            <li className="tb-section-item tb-section-item-lable">
              account number
            </li>
            <li className="tb-section-item tb-section-item-lable">IFSC Code</li>{" "}
          </>
        )}
      </ul>

      <ul className="tb-section tb-section-2">
        {modName === "all_documents" && (
          <>
            <li className="tb-section-item tb-section-item-lable-value">
              {lease_agreement ? (
                <a href={lease_agreement}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-cloud-arrow-down"
                    viewBox="0 0 16 16"
                    style={{
                      color: "#209216",
                      minWidth: "35px",
                      minHeight: "35px",
                    }}
                  >
                    <path
                      fillRule="evenodd"
                      d="M7.646 10.854a.5.5 0 0 0 .708 0l2-2a.5.5 0 0 0-.708-.708L8.5 9.293V5.5a.5.5 0 0 0-1 0v3.793L6.354 8.146a.5.5 0 1 0-.708.708z"
                    />
                    <path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383m.653.757c-.757.653-1.153 1.44-1.153 2.056v.448l-.445.049C2.064 6.805 1 7.952 1 9.318 1 10.785 2.23 12 3.781 12h8.906C13.98 12 15 10.988 15 9.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 4.825 10.328 3 8 3a4.53 4.53 0 0 0-2.941 1.1z" />
                  </svg>
                </a>
              ) : (
                <CrossCircleIcon />
              )}
            </li>
            <li className="tb-section-item tb-section-item-lable-value">
              {electricity_bill ? (
                <a href={electricity_bill}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-cloud-arrow-down"
                    viewBox="0 0 16 16"
                    style={{
                      color: "#209216",
                      minWidth: "35px",
                      minHeight: "35px",
                    }}
                  >
                    <path
                      fillRule="evenodd"
                      d="M7.646 10.854a.5.5 0 0 0 .708 0l2-2a.5.5 0 0 0-.708-.708L8.5 9.293V5.5a.5.5 0 0 0-1 0v3.793L6.354 8.146a.5.5 0 1 0-.708.708z"
                    />
                    <path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383m.653.757c-.757.653-1.153 1.44-1.153 2.056v.448l-.445.049C2.064 6.805 1 7.952 1 9.318 1 10.785 2.23 12 3.781 12h8.906C13.98 12 15 10.988 15 9.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 4.825 10.328 3 8 3a4.53 4.53 0 0 0-2.941 1.1z" />
                  </svg>
                </a>
              ) : (
                <CrossCircleIcon />
              )}
            </li>
            <li className="tb-section-item tb-section-item-lable-value">
              {bank_statement ? (
                <a href={bank_statement}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-cloud-arrow-down"
                    viewBox="0 0 16 16"
                    style={{
                      color: "#209216",
                      minWidth: "35px",
                      minHeight: "35px",
                    }}
                  >
                    <path
                      fillRule="evenodd"
                      d="M7.646 10.854a.5.5 0 0 0 .708 0l2-2a.5.5 0 0 0-.708-.708L8.5 9.293V5.5a.5.5 0 0 0-1 0v3.793L6.354 8.146a.5.5 0 1 0-.708.708z"
                    />
                    <path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383m.653.757c-.757.653-1.153 1.44-1.153 2.056v.448l-.445.049C2.064 6.805 1 7.952 1 9.318 1 10.785 2.23 12 3.781 12h8.906C13.98 12 15 10.988 15 9.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 4.825 10.328 3 8 3a4.53 4.53 0 0 0-2.941 1.1z" />
                  </svg>
                </a>
              ) : (
                <CrossCircleIcon />
              )}
            </li>{" "}
          </>
        )}

        {modName === "bank_statement" && (
          <>
            <li className="tb-section-item tb-section-item-lable-value">
              {bank_name || "NA"}
            </li>
            <li className="tb-section-item tb-section-item-lable-value">
              {account_number || "NA"}
            </li>
            <li className="tb-section-item tb-section-item-lable-value">
              {ifsc_code || "NA"}
            </li>
          </>
        )}
      </ul>
    </div>
  );
};

export default BankDetails;
